module.exports = __webpack_public_path__ + "static/media/points-portal2.51a9c041.51a9c041.JPG";